import React from 'react';

import type { OAISchema } from '~/types/openapi';

type Props = OAISchema['MarketProductDetailsResponseV2'];

function ProductSubImages({
  contentImages = [],
}: Pick<Props, 'offerId' | 'status' | 'productCode' | 'contentImages'>) {
  return (
    <div className="mb-16">
      {contentImages.map((src, index) => {
        const key = `product-detail-img-${index}`;
        // 어떤 비율의 이미지가 올지 조차 알 수 없기 때문에 일반 img 태그 사용
        return <img key={key} src={src} alt={key} />;
      })}
    </div>
  );
}
export default ProductSubImages;
